module.exports = "//public.getcloudapp.com/packs/media/images/new_annotate/move-1ba160958b28e506730d4116fe428365.svg";